import { apiClient } from "./api";

export const usporadatelApi = {
  listTopics: async () => {
    const topics = [];
    let cursor;
    do {
      const query = new URLSearchParams({ limit: "100" });
      if (cursor) query.set("cursor", cursor);
      const page = await apiClient.get(`/usporadatel/topics?${query}`);
      topics.push(...page.topics);
      cursor = page.nextCursor;
    } while (cursor);
    return { topics };
  },
  getTopic: (topicId) => apiClient.get(`/usporadatel/topics/${encodeURIComponent(topicId)}`),
  markTopicRead: (topicId, expectedVersion) => apiClient.post(
    `/usporadatel/topics/${encodeURIComponent(topicId)}/mark-read`,
    {
      expectedVersion,
      disclosureId: `web:${crypto.randomUUID()}`,
      readBy: "web",
    },
  ),
  getRevisions: (topicId) => apiClient.get(`/usporadatel/topics/${encodeURIComponent(topicId)}/revisions?limit=100`),
  listJobs: () => apiClient.get("/usporadatel/jobs?limit=100"),
  listReconciliations: () => apiClient.get("/usporadatel/reconciliations?limit=100"),
  getReconciliation: (runId) => apiClient.get(`/usporadatel/reconciliations/${encodeURIComponent(runId)}?limit=100`),
  getWakePrompt: () => apiClient.get("/usporadatel-wake-prompt"),
  saveWakePrompt: (prompt) => apiClient.put("/usporadatel-wake-prompt", { prompt }),
  restoreWakePrompt: (version) => apiClient.put("/usporadatel-wake-prompt", { activateVersion: version }),
};